import {orderColumns, useGetOrders} from '@entities/order';
import {MrTable} from '@shared/components';
import {entityTableCommonProps} from '@shared/constants';
import {useUrlState} from '@shared/hooks';
import {Header} from '@widgets/common';

import {PaginationState} from '@/shared/types';

// Bumped: the column set and their order have changed
const localStorageKey = 'orderTableV6';

type UrlState = PaginationState;

export const OrdersPage = () => {
  const {urlState, setUrl} = useUrlState<UrlState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const {
    data,
    isPending: isLoading,
    error,
  } = useGetOrders({
    page: urlState.pageIndex + 1,
    pageSize: urlState.pageSize,
  });

  return (
    <MrTable
      error={error}
      columns={orderColumns}
      data={data?.items ?? []}
      renderTopToolbarCustomActions={() => {
        return <Header title="Orders" isBackButtonShown={false} />;
      }}
      enableColumnOrdering
      enableColumnDragging={false}
      localStorageKeyForSettings={localStorageKey}
      enableHiding
      /////////////////////////////
      // pagination + state
      enablePagination
      manualPagination
      onPaginationChange={setUrl}
      rowCount={data?.total ?? 0}
      /////////////////////////////
      state={{
        isLoading,
        pagination: urlState,
      }}
      enableColumnPinning
      initialState={{
        columnPinning: {
          left: ['id'],
        },
      }}
      {...entityTableCommonProps}
      enableRowActions={false}
    />
  );
};
